import { IQuickApp, TQuickAppsMeta } from 'client/model/privateApps';
import { Channel } from 'client/model/skill';

import { routes } from '../../lib/routes';
import { callApi } from '../utils';

export function getQuickApps() {
    return callApi<IQuickApp[]>({
        method: 'GET',
        url: routes.app.appStoreApi('quick-apps/apps'),
    });
}

export function deleteQuickApp(id: string, channel: string) {
    const appIdURLEncoded = encodeURIComponent(id);
    return callApi<void>({
        method: 'DELETE',
        url: routes.app.appStoreApi('quick-apps/app'),
        queryParams: { id: appIdURLEncoded, channel },
    });
}

export function getQuickAppsMetaInfo() {
    return callApi<{
        storage_info: TQuickAppsMeta;
    }>({
        method: 'GET',
        url: routes.app.appStoreApi('quick-apps/meta-info'),
    });
}

export function quickAppUploadApk(channel: Channel, file: File) {
    const form = new FormData();

    form.append('file', file);

    return callApi<string>({
        method: 'POST',
        url: routes.app.appStoreApi('quick-apps/upload-apk'),
        queryParams: {
            channel,
        },
        data: form,
    });
}
